<template>
  <v-dialog
    v-model="isOpen"
    persistent
    class="out-of-station-alert"
  >
    <v-card>
      <v-card-title>
        <v-img src="~/assets/images/icons/ic_warning_danger.png" class="icons d-flex justify-center w-100" />
        <h2 class="alert-title">
          警告
        </h2>
      </v-card-title>
      <v-card-text>
        <p class="alert-message">
          駅内に戻って作業を行なってください。
        </p>
        <p class="alert-message2 mt-2">
          ※戻れない場合は下記「ホームに戻る」ボタンをタップしてください。
        </p>
        <div class="w-100 mt-5">
          <CustomButton
            variant="outlined"
            @click="$router.push('/')"
          >
            ホームに戻る
          </CustomButton>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import CustomButton from '~/components/common/parts/CustomButton.vue';

const { shouldShowOutOfStationAlert } = useStationAreaConditions();

const isOpen = shouldShowOutOfStationAlert;
</script>

<style scoped lang="scss">
@use '~/assets/scss/_base.scss' as vars;

.out-of-station-alert {
  z-index: 99998 !important;
  max-width: vars.$modal-max-width;

  .v-card {
    padding: 24px;
    text-align: center;
  }

  .alert-title {
    margin: 0;
    font-size: 48px;
    font-weight: bold; /* フォントの太さ */
    color: #f44336; /* 赤色 */
  }

  .v-card-text {
    padding: 0 !important;
  }

  .alert-message {
    margin: 0;
    font-size: 24px; /* メッセージのフォントサイズ */
    font-weight: bold; /* フォントの太さ */
    color: #f44336; /* 赤色 */
    text-align: left; /* 左寄せ */
  }

  .alert-message2 {
    margin: 0;
    font-size: 20px; /* メッセージのフォントサイズ */
    font-weight: bold; /* フォントの太さ */
    text-align: left; /* 左寄せ */
  }
}

.icons {
  width: 80px;
  height: 80px;
}
</style>
